import AppProviders from "./providers/AppProviders";

import AppRouter from "./routes/AppRouter";

import PwaManager from "../shared/pwa/PwaManager";

const App = () => (
  <AppProviders>
    <AppRouter />
    <PwaManager />
  </AppProviders>
);

export default App;
